import React, { useEffect, useState } from 'react';
interface AutoCarouselProps {
  images: string[];
  interval?: number;
  className?: string;
}
export function AutoCarousel({
  images,
  interval = 2000,
  className = 'h-64'
}: AutoCarouselProps) {
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % images.length);
    }, interval);
    return () => clearInterval(timer);
  }, [images.length, interval]);
  return <div className={`relative w-full overflow-hidden bg-beige-claro ${className}`} data-id="element-9">
      <img src={images[currentIndex]} className="absolute inset-0 w-full h-full object-cover" alt="Creación artesanal" data-id="element-10" />
    </div>;
}